"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Phone, Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function ContactDetails() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="contact-details-map" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 border-b border-border">
      <div className="mx-auto max-w-7xl px-5 md:px-8 lg:px-12">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-3xl">
          {/* Eyebrow indicator */}
          <div className="flex items-center gap-2 mb-3">
            <div className="h-0.5 w-6 bg-primary" />
            <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
              Direct Communications & Dispatch
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            Contact our scaffolding team
          </h1>

          {/* Subtitle / Description */}
          <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Commercial, residential and specialist scaffolding across the South East, Greater London and the Home Counties. Call, email or send us your project details and our team will come back to you.
          </p>

          {/* Action Buttons: Stacked on Mobile, Side by Side on Desktop */}
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3.5 sm:gap-4">
            <Button asChild size="lg" className="h-12 sm:h-13 px-6 text-sm sm:text-base font-semibold shadow-xs">
              <a href="tel:01344929900" className="inline-flex items-center justify-center gap-2.5">
                <Phone className="size-4.5 shrink-0" aria-hidden="true" />
                <span>Call BMF — 01344 929900</span>
              </a>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-12 sm:h-13 px-6 text-sm sm:text-base font-semibold border-border hover:border-primary/50">
              <a href="mailto:quotes@bmfscaffolding.co.uk" className="inline-flex items-center justify-center gap-2.5">
                <Mail className="size-4.5 shrink-0 text-primary" aria-hidden="true" />
                <span>Email BMF — quotes@bmfscaffolding.co.uk</span>
              </a>
            </Button>
          </div>

          {/* Supporting Text Line */}
          <div className="mt-4 flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
            <Clock className="size-3.5 text-muted-foreground/80 shrink-0" aria-hidden="true" />
            <span>Monday to Friday, 8am–6pm</span>
          </div>
        </motion.div>
      </div>
    </section>;
}